<p-dialog [header]="modalTitle" [(visible)]="displayDialog" (onHide)="onCancel()" showeffect="fade" [modal]="true" [closable]="true"
  [styleClass]="'add-dialog'" [blockScroll]="true">
  <div class="modal-table-wrapper">
  <div class="modal-loading" *ngIf="isLoading">
    <app-tab-spinner [fixed]="false"></app-tab-spinner>
  </div>
  <div class="modal-content" *ngIf="!isLoading">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <div class="grid">
        <div class="col-4">
          <form-field [formField]="formFields[0]" [form]="form"></form-field>
        </div>
      </div>
      <div class="grid">
        <div class="col-6">
          <form-field [formField]="formFields[1]" [form]="form"></form-field>
        </div>
      </div>
      <div class="grid">
        <div class="col-6">
          <form-field [formField]="formFields[2]" [form]="form"></form-field>
        </div>
      </div>
      <div class="grid">
        <div class="col-6">
          <form-field [formField]="formFields[3]" [form]="form"></form-field>
        </div>
      </div>
      <div class="grid">
        <div class="col-12">
          <form-field [formField]="formFields[4]" [form]="form"></form-field>
        </div>
      </div>
      <div class="grid" *ngIf="modalTitle === 'Send Info Email'">
        <div class="grid">
          <div class="col-12">
            <label for="attachments" class="form-label" style="font-size: 0.75rem; color: #2f3133; margin-left: 12px;">Attachments </label>
            <input
              type="file"
              id="attachments"
              (change)="onFileSelected($event)"
              multiple
            />
          </div>
        </div>
        <div class="col-12">
          <form-field [formField]="formFields[5]" [form]="form"></form-field>
        </div>
      </div>
    </form>
  </div>
  </div>
  <p-toast> </p-toast>
  <ng-template pTemplate="footer">
    <div class="p-dialog-buttonpane ui-helper-clearfix send-email-modal-footer">
      <div class="send-email-modal-footer__left">
        <button class="crm-button" type="button" (click)="downloadPdf()" label="DownloadPDF">
          Download PDF
        </button>
      </div>
      <div class="send-email-modal-footer__right">
        <button class="crm-button" type="button" (click)="onContinueWOEmailFax()" label="ContinueWOEmailFax">
          Continue without Email/Fax
        </button>
        <button class="crm-button" type="submit" (click)="onSubmit()" [disabled]="inProgress" label="Send">Send</button>
        <button class="crm-button" type="button" (click)="onCancel()" [disabled]="inProgress" label="Cancel">Cancel</button>
      </div>
    </div>
  </ng-template>
</p-dialog>